/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import Flatpickr from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn.js"
import { useIntl } from 'react-intl'
import { DEFAULT_PER_PAGE } from '../../constants/common'
import { MstTaxGroupModel } from '../../models/MstTaxGroupModel'
import moment from 'moment';

type Props = {
  show: boolean
  mode: string
  data?: MstTaxGroupModel
  validDate?: string
  onClose: () => void
  onSubmit: (values: any, actions: any) => void
}

const editSchema = Yup.object().shape({
  name: Yup.string().required('Tên nhóm không được bỏ trống.').max(255).label('Tên nhóm'),
  vat_rate: Yup.number().min(0, 'Thuế GTGT lớn hơn hoặc bằng 0').required().label('Thuế GTGT'),
  pit_rate: Yup.number().min(0, 'Thuế TNCN lớn hơn hoặc bằng 0').required().label('Thuế TNCN')
});

const initSearch = {
  page: 1,
  per_page: DEFAULT_PER_PAGE,
}


const TaxGroupEditModal: React.FC<Props> = ({ show, mode, data, onClose, onSubmit }) => {
  const intl = useIntl();

  useEffect(() => {
    
  }, [show]);
  let initValues: any = {
    name: '',
    vat_rate: 0,
    pit_rate: 0,
  };
  if (data) {
    initValues = {
      ...initValues,
      id: data.id,
      name: data.name,
      vat_rate: data.vat_rate ?? 0,
      pit_rate: data.pit_rate ?? 0,
      effective_from: data.effective_from ?? null,
      effective_to: data.effective_to ?? null
    }
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby='contained-modal-title-vcenter'
      centered
      className='modal-overflow-y'
    >
      <Modal.Header className='d-flex'>
        <Modal.Title>Nhóm ngành: {data?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-10">
        <Formik validationSchema={editSchema} initialValues={initValues} onSubmit={onSubmit} validateOnMount initialTouched={initValues}>
          {({ values, handleChange }) => (
            <Form>
                <div className="d-flex flex-column  gap-5 pt-3">
                    <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                        <label className="required form-label">Tên nhóm</label>
                            <Field
                            type='text'
                            className='form-control'
                            placeholder=''
                            autoComplete='nope'
                            name='name'
                        />
                        <ErrorMessage className='text-danger' component='span' name='name' />
                    </div>
                    <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                        <label className="required form-label">Thuế GTGT</label>
                            <Field
                            type='number'
                            className='form-control'
                            placeholder=''
                            autoComplete='nope'
                            name='vat_rate'
                        />
                        <ErrorMessage className='text-danger' component='span' name='vat_rate' />
                    </div>
                    <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                        <label className="required form-label">Thuế TNCN</label>
                            <Field
                              type='number'
                              className='form-control'
                              placeholder=''
                              autoComplete='nope'
                              name='pit_rate'
                          />
                        <ErrorMessage className='text-danger' component='span' name='pit_rate' />
                    </div>
                    {/* <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                        <label className=" form-label">Hiệu lực từ</label>
                        <Flatpickr
                            onChange={(date) => {
                                handleChange({target: {name: 'effective_from', value: moment(date[0]).format('YYYY-MM-DD')}});
                            }}
                            options={{
                                mode: "single",
                                dateFormat: "d-m-Y",
                                locale: Vietnamese,
                                shorthandCurrentMonth: true
                            }}
                            className='form-control'
                            placeholder=''
                        />
                        <ErrorMessage className='text-danger' component='span' name='effective_from' />
                    </div>
                    <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                        <label className=" form-label">Hiệu lực đến</label>
                        <Flatpickr
                            onChange={(date) => {
                                handleChange({target: {name: 'effective_to', value: moment(date[0]).format('YYYY-MM-DD')}});
                            }}
                            options={{
                                mode: "single",
                                dateFormat: "d-m-Y",
                                locale: Vietnamese,
                                shorthandCurrentMonth: true
                            }}
                            className='form-control'
                            placeholder=''
                        />
                        <ErrorMessage className='text-danger' component='span' name='effective_to' />
                    </div> */}
                </div>
                <div className='d-flex mb-4 justify-content-between pt-8'>
                    <button className="btn btn-bg-secondary" type="button" onClick={() => onClose()}>Hủy</button>
                    <button className="btn btn-bg-success" type="submit">Lưu</button>
                </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default TaxGroupEditModal
